<p-confirmDialog #cd key="globalTimeout" [closable]="false" autofocus="false" defaultButton="reject" class='emtr-warning-box global-timeout' [ariaLabel]="'Global Timeout Warning'">
  <p-footer>
    <div class="sdps-p-top_small border-top-line">
      <button type="button" id="warning-accept" class="cursor button p-confirmdialog-accept-button sdps-p-vertical_xx-small sdps-p-horizontal_xx-small"
      pButton [label]="logOut" (click)="cd.accept()"></button>
      <button type="button" id="warning-reject" class="buttons p-confirmdialog-reject-button sdps-p-vertical_xx-small sdps-p-horizontal_xx-small"
      pButton [label]="stayLoggedIn" (click)="cd.reject()"></button>
    </div>
  </p-footer>
</p-confirmDialog>